import { render } from "./Subscriptions.vue?vue&type=template&id=f99b6b6a&scoped=true&ts=true"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"

import "./Subscriptions.vue?vue&type=style&index=0&id=f99b6b6a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99b6b6a"]])

export default __exports__